import React from 'react';
import { PARKING_OPTIONS } from '../../../util/listing-search.constants';
import { iconCar } from '../../../util/icons';

export interface ParkingProps {
  parkingSpaces?: number;
  setSearchOption(key: string, value: string | number): void;
}

export const Parking: React.FC<ParkingProps> = props => {

  return (
    <div className="form-field">
      <div className="form-field-label"><span className="icon">{iconCar}</span> Parking</div>
      <div className="button-row">
        {PARKING_OPTIONS.map((option, i) => <button key={i} className={props.parkingSpaces === option.value ? 'enabled' : ''} onClick={() => props.setSearchOption('parkingSpaces', option.value)}>{option.label}</button>)}
      </div>
    </div>
  );
}
